import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";

import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Hidden,
  InputBase,
  Paper,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
// import DateFnsUtils from '@date-io/date-fns';
// import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import EmailIcon from "@material-ui/icons/Email";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
// import SearchIcon from '@material-ui/icons/Search';
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MoreIcon from "@material-ui/icons/MoreVert";
import RefreshIcon from "@material-ui/icons/Refresh";
import FilterListIcon from "@material-ui/icons/FilterList";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  paperRoot: {
    width: 650,
    maxWidth: "100%",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
    marginLeft: theme.spacing(4),
  },
  minPaperRoot: {
    width: 400,
    maxWidth: "100%",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  advanceCard: {
    margin: theme.spacing(0.4, 0),
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1),
    position: "absolute",
    width: 650,
    minWidth: 650,
    overflow: "auto",
    zIndex: 3,
    [theme.breakpoints.up("sm")]: {
      maxWidth: "50%",
    },
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
  MenuItem: {
    fontSize: "14px",
  },
  listCount: {
    fontSize: "12px",
    fontWeight: 600,
    maxidth: "100%",
    padding: "4px 8px",
    borderRadius: "4px",
    color: theme.palette.text.disabled,
    backgroundColor: lighten(theme.palette.action.disabled, 0.9),
  },
}));

export const TableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    numSelected,
    tableTitle,
    listCount,
    isCheckbox,
    isEnable,
    handleRefresh,
    handleCheckbox,
    handleSearch,
  } = props;

  // const [isOpen, setIsOpen] = useState(false);
  // const advancedToggleHandler = () => setIsOpen(!isOpen);

  const inputSearchRef = useRef();
  const [enteredFilter, setEnteredFilter] = useState("");

  const [filterActive, setFilterActive] = useState(null);
  const handleFilterOpen = (event) => setFilterActive(event.currentTarget);
  const handleFilterClose = (event) => setFilterActive(null);

  const [isMenuList, setIsMenuList] = useState(null);
  const handleMenuList = (event) => setIsMenuList(event.currentTarget);
  const handleMenuListClose = () => setIsMenuList(null);

  useEffect(() => {
    let unmounted = false;

    if (!unmounted) {
      handleSearch();
    }

    return () => {
      unmounted = true;
    };
  }, [handleSearch]);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const filterHandler = useCallback(
    (value, index) => {
      // const query = value.length !== 0 ? `&status=${value}` : "";
      handleSearch(value);
      // handleFilterClose();
      setSelectedIndex(index);
    },
    [handleSearch, selectedIndex, setSelectedIndex],
  );

  const filterOptions = [
    { id: 0, title: "All", option: "" },
    { id: 1, title: "Confirmed", option: "Confirmed" },
    { id: 2, title: "Timesheet Submitted", option: "Timesheet Submitted" },
    { id: 3, title: "Approved", option: "Approved" },
    { id: 4, title: "Paid", option: "Paid" },
    { id: 5, title: "Cancelled", option: "Cancel" },
  ];

  return (
    <React.Fragment>
      {/* <DevTool control={control} /> */}
      <Toolbar
        className={clsx(classes.root, {
          [classes.highlight]: numSelected > 0,
        })}
      >
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          {/* Toolbar title */}
          <Grid item>
            {numSelected > 0 ? (
              <Typography
                className={classes.title}
                color="inherit"
                variant="subtitle1"
                component="div"
              >
                {numSelected} selected
              </Typography>
            ) : (
              <Typography
                className={classes.title}
                variant="h6"
                id="tableTitle"
                component="div"
              >
                {tableTitle} |{" "}
                <span className={classes.listCount}>{listCount}</span>
              </Typography>
            )}
          </Grid>

          {numSelected > 0 ? (
            <Tooltip title="Email To">
              <IconButton aria-label="emailTo">
                <EmailIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <React.Fragment>
              {/* Right action */}
              <Grid item>
                {/* Hide in small screen*/}
                <Hidden only={["sm", "xs"]}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="flex-start"
                  >
                    {/* Filter icon */}
                    <Grid item xs>
                      <Tooltip title="Filter status">
                        <IconButton
                          aria-label="filter status list"
                          aria-haspopup="true"
                          onClick={handleFilterOpen}
                        >
                          <FilterListIcon />
                        </IconButton>
                      </Tooltip>

                      <Menu
                        id="filter-menu"
                        anchorEl={filterActive}
                        keepMounted
                        open={Boolean(filterActive)}
                        onClose={handleFilterClose}
                      >
                        {filterOptions.map((item, index) => (
                          <MenuItem
                            className={classes.MenuItem}
                            key={item.id}
                            selected={index === selectedIndex}
                            onClick={(e) => filterHandler(item.option, index)}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                      </Menu>
                    </Grid>
                    {/* Refresh icon */}
                    <Grid item xs>
                      <Tooltip title="Refresh">
                        <IconButton
                          aria-label="Refresh Data"
                          color="primary"
                          aria-haspopup="true"
                          onClick={handleRefresh}
                        >
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    {/* Toggle icon */}
                    {isEnable && (
                      <Grid item xs>
                        <Tooltip
                          title={
                            isCheckbox ? "Disable Checkbox" : "Enable Checkbox"
                          }
                        >
                          {isCheckbox ? (
                            <IconButton
                              aria-label="Checkbox"
                              color="primary"
                              onClick={handleCheckbox}
                            >
                              <ToggleOnIcon />
                            </IconButton>
                          ) : (
                            <IconButton
                              aria-label="Checkbox"
                              color="secondary"
                              onClick={handleCheckbox}
                            >
                              <ToggleOffIcon />
                            </IconButton>
                          )}
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>
                </Hidden>
                {/* Appear in small screen */}
                <Hidden mdUp>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                  >
                    <Grid item xs={6}>
                      <Paper component="form" className={classes.minPaperRoot}>
                        <InputBase
                          placeholder="Search"
                          inputProps={{ "aria-label": "search" }}
                          inputRef={inputSearchRef}
                          value={enteredFilter}
                          onChange={(event) =>
                            setEnteredFilter(event.target.value)
                          }
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <IconButton
                        aria-label="show more"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={handleMenuList}
                      >
                        <MoreIcon />
                      </IconButton>
                      <Menu
                        id="simple-menu"
                        anchorEl={isMenuList}
                        keepMounted
                        open={Boolean(isMenuList)}
                        onClose={handleMenuListClose}
                      >
                        <MenuItem onClick={handleRefresh}>Refresh</MenuItem>
                      </Menu>
                    </Grid>
                  </Grid>
                </Hidden>
              </Grid>
            </React.Fragment>
          )}
        </Grid>
      </Toolbar>
    </React.Fragment>
  );
};

TableToolbar.propTypes = { numSelected: PropTypes.number.isRequired };
